module.exports = new __parcel__URL__("the-sims.df7c2b39.jpg").toString();